import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'reactstrap';
import Slider from 'rc-slider';

import {
  undo, redo, toggleLayers, toggleGrid, setZoom,
  alignHorizontalLeft, alignHorizontalCenter, alignHorizontalRight,
  alignVerticalTop, alignVerticalCenter, alignVerticalBottom,
  toggleGuide, flipHorizontal, flipVertical,
  setFacePenMode, setPenStrokeWidth, closeTour
} from "../../actions";

class FaceToolbar extends Component {

  constructor(props) {
    super(props);
    this.handleUndo = this.handleUndo.bind(this);
    this.handleRedo = this.handleRedo.bind(this);
    this.handleToggleLayers = this.handleToggleLayers.bind(this);
    this.handleHorizontalAlignLeft = this.handleHorizontalAlignLeft.bind(this);
    this.handleHorizontalAlignCenter = this.handleHorizontalAlignCenter.bind(this);
    this.handleHorizontalAlignRight = this.handleHorizontalAlignRight.bind(this);
    this.handleVerticalAlignTop = this.handleVerticalAlignTop.bind(this);
    this.handleVerticalAlignCenter = this.handleVerticalAlignCenter.bind(this);
    this.handleVerticalAlignBottom = this.handleVerticalAlignBottom.bind(this);
    this.handleToggleGrid = this.handleToggleGrid.bind(this);
    this.handleZoomUp = this.handleZoomUp.bind(this);
    this.handleZoomDown = this.handleZoomDown.bind(this);
    this.handleZoomChange = this.handleZoomChange.bind(this);
    this.handleToggleGuide = this.handleToggleGuide.bind(this);
    this.handleFlipVertical = this.handleFlipVertical.bind(this);
    this.handleFlipHorizontal = this.handleFlipHorizontal.bind(this);
  }

  handleUndo() {
    this.props.undo();
  }

  handleRedo() {
    this.props.redo();
  }

  handleToggleLayers() {
    this.props.toggleLayers();
  }

  handleHorizontalAlignLeft() {
    this.props.alignHorizontalLeft(this.props.layers.selected);
  }

  handleHorizontalAlignCenter() {
    this.props.alignHorizontalCenter(this.props.layers.selected);
  }

  handleHorizontalAlignRight() {
    this.props.alignHorizontalRight(this.props.layers.selected);
  }

  handleVerticalAlignTop() {
    this.props.alignVerticalTop(this.props.layers.selected);
  }

  handleVerticalAlignCenter() {
    this.props.alignVerticalCenter(this.props.layers.selected);
  }

  handleVerticalAlignBottom() {
    this.props.alignVerticalBottom(this.props.layers.selected);
  }

  handleToggleGrid() {
    this.props.toggleGrid();
  }

  handleToggleGuide() {
    this.props.toggleGuide();
  }

  handleZoomChange(value) {
    this.props.setZoom(value);
  }

  handleZoomUp() {
    this.props.setZoom(this.props.canvas.zoom + 0.1);
  }

  handleZoomDown() {
    this.props.setZoom(this.props.canvas.zoom - 0.1);
  }

  handleFlipVertical() {
    this.props.flipVertical(this.props.layers.selected);
  }

  handleFlipHorizontal() {
    this.props.flipHorizontal(this.props.layers.selected);
  }

  handleStrokeWidthHOC(size, mode) {
    return () => {
      this.props.setPenStrokeWidth(size, mode);
      this.props.closeTour(2);
    }
  }

  render() {
    // const surfaceId = this.props.objects.present.currentSurface.surface.id;

    const isUndoEnabled = (this.props.lines.past.length > 0);
    const isRedoEnabled = (this.props.lines.future.length > 0);
    // const isGrouped = (this.props.layers.selected.length > 1);

    const isZoomUpEnabled = this.props.canvas.zoom < 4.0;
    const isZoomDownEnabled = this.props.canvas.zoom > 0.5;
    //const isZoomResetEnabled = this.props.canvas.zoom !== 1.0;
    // const isFlippable = (this.props.layers.selected.length === 1) && this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]].type !== 'text';

    return (
        <div className="t-toolbar bg-dark t-face-toolbar">
          <ButtonGroup className="mr-1">
            <Button className="with-text" data-tip="元に戻す" onClick={this.handleUndo} disabled={!isUndoEnabled}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-undo.png"} alt="" width={18} /> 戻る
            </Button>
            <Button className="with-text" data-tip="やり直し" onClick={this.handleRedo} disabled={!isRedoEnabled}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-redo.png"} alt="" width={18}/> 進む
            </Button>

          </ButtonGroup>
          <span className="label">消しゴムツール</span>
          <ButtonGroup className="tour-2">
            <Button onClick={this.handleStrokeWidthHOC(10, 'source-over')} active={this.props.meishi.mode === 'source-over' && this.props.meishi.strokeWidth === 10}><span className="circle10" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(20, 'source-over')} active={this.props.meishi.mode === 'source-over' && this.props.meishi.strokeWidth === 20}><span className="circle20" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(30, 'source-over')} active={this.props.meishi.mode === 'source-over' && this.props.meishi.strokeWidth === 30}><span className="circle30" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(40, 'source-over')} active={this.props.meishi.mode === 'source-over' && this.props.meishi.strokeWidth === 40}><span className="circle40" /></Button>
          </ButtonGroup>
          <span className="label">修復ツール</span>
          <ButtonGroup className="tour-3">
            <Button onClick={this.handleStrokeWidthHOC(10, 'destination-out')} active={this.props.meishi.mode === 'destination-out' && this.props.meishi.strokeWidth === 10}><span className="circle10 circle-alt" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(20, 'destination-out')} active={this.props.meishi.mode === 'destination-out' && this.props.meishi.strokeWidth === 20}><span className="circle20 circle-alt" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(30, 'destination-out')} active={this.props.meishi.mode === 'destination-out' && this.props.meishi.strokeWidth === 30}><span className="circle30 circle-alt" /></Button>
            <Button onClick={this.handleStrokeWidthHOC(40, 'destination-out')} active={this.props.meishi.mode === 'destination-out' && this.props.meishi.strokeWidth === 40}><span className="circle40 circle-alt" /></Button>
          </ButtonGroup>

          <div className="t-toolbar-right">
            {/*<ButtonGroup className="mr-1">*/}
            {/*  <Button data-tip="ガイド枠表示" onClick={this.handleToggleGuide} active={this.props.canvas.guide}>*/}
            {/*    <img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-guide.png"} alt="" width={20}/>*/}
            {/*  </Button>*/}
            {/*</ButtonGroup>*/}
            <ButtonGroup>
              <Button  onClick={this.handleZoomDown} disabled={!isZoomDownEnabled}><img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-zoom-out.png"} alt="" /></Button>
            </ButtonGroup>
            <div className="t-toolbar-slider">
              <Slider min={0.5} max={4.0} step={0.1} defaultValue={1.0} value={this.props.canvas.zoom} onChange={this.handleZoomChange} />
            </div>
            <ButtonGroup>
              <Button  onClick={this.handleZoomUp} disabled={!isZoomUpEnabled}><img src={window.tProjectGlobals.assetBaseUrl + "img/toolbar-zoom-in.png"} alt=""/></Button>
            </ButtonGroup>
          </div>
        </div>
    );
  }
}

export default connect(f => f, {
  undo, redo, toggleLayers, toggleGrid, setZoom,
  alignHorizontalLeft, alignHorizontalCenter, alignHorizontalRight,
  alignVerticalTop, alignVerticalCenter, alignVerticalBottom,
  toggleGuide, flipHorizontal, flipVertical,
  setFacePenMode, setPenStrokeWidth, closeTour
})(FaceToolbar);



// WEBPACK FOOTER //
// ./src/components/Face/FaceToolbar.js